import { render, staticRenderFns } from "./WebchargeSettings.vue?vue&type=template&id=0168593a&scoped=true"
import script from "./WebchargeSettings.vue?vue&type=script&lang=ts"
export * from "./WebchargeSettings.vue?vue&type=script&lang=ts"
import style0 from "@/components/settings/styles/settings-styles.css?vue&type=style&index=0&id=0168593a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168593a",
  null
  
)

/* custom blocks */
import block0 from "@/components/settings/locales/i18n-webcharge-setting-overview.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fsettings%2FWebchargeSettings.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports